// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    organizationScopeId: z.string().min(1).max(21),
});
const guard = z.object({
    tenantId: z.string().max(21),
    organizationScopeId: z.string().min(1).max(21),
});
export const CimdOrganizationScopes = Object.freeze({
    table: 'cimd_organization_scopes',
    tableSingular: 'cimd_organization_scope',
    fields: {
        tenantId: 'tenant_id',
        organizationScopeId: 'organization_scope_id',
    },
    fieldKeys: [
        'tenantId',
        'organizationScopeId',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
